import * as React from "react";
import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes } from "@blueprintjs/core";
import { Button, Card,H4,Intent, Elevation, Overlay } from "@blueprintjs/core";
import{HomeProps} from './Home.tsx'
import{CardPdf} from './CardPdf.tsx'
import {CardQuizz} from './CardQuizz.tsx'
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
    MultistepDialog,
    DialogStep,
    ButtonProps,
    RadioGroup,
    Radio,
    NumericInput,
    Label,
} from "@blueprintjs/core";
import PanelNom from './PanelNom.tsx';
import PanelEmail from './PanelEmail.tsx';
import PanelPassword from './PanelPassword.tsx';
import PanelOnePassword from './PanelOnePassword.tsx';
import CardDocument from './CardDocument.tsx';
import CardImage from './CardImage.tsx';
import { type, userInfo } from "os";
import CardDraggable from "./CardDraggable.tsx";



export default class CardDocumentsConfig extends React.Component  <HomeProps> {
  state = {
    nom_cours: '',
    force_width:250,
    isDocOpen:'none',
    isOpen:false
  }  
  constructor(props) {
        super(props);
        
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
   
    if(this.props.config=='true')this.setState({force_width:480});
    
  }
 
  componentDidUpdate(prevProps, prevState) {
    
  }
  handleChange=function (ev)
  {
    console.log(ev.target.value);
    this.setState({nom_cours:ev.target.value});
  }.bind(this);

  handleClick=function()
  {
     
  const toaster=Toaster.create({
    className: "my-toaster",
    position: Position.TOP_RIGHT,
  });
  if(this.state.nom_cours==""){
    toaster.show( {icon:"manual", intent:Intent.DANGER,timeout:5000,message:"Le cours doit avoir un nom"}); 
    return;
  }
  var that=this;
  var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  var formData = new FormData();
  formData.append('nom', this.state.nom_cours);
  formData.append('id_matiere', this.props.matiere_id);
  formData.append('description', "");

  xhr.open('POST','/api/public/createcours')
  
  xhr.setRequestHeader("Content-Type", "application/json");

  //send the form data
  xhr.send(JSON.stringify(Object.fromEntries(formData)));

        xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                          
             if(xhr.status==200) 
             { 
             
              console.log(xhr.responseText);
              that.props.onchildrenevent();
              toaster.show( {icon:"manual", intent:Intent.SUCCESS,timeout:3000,message:"Cours "+ that.state.nom_cours+ " créée"});
              return;
               var jsonResponse = JSON.parse(xhr.responseText);
               console.log(jsonResponse);
              
               
              
             }
             if(xhr.status==404) {toaster.show( {message:"erreur"}); }
             if(xhr.status==500) {toaster.show( {message:"erreur"}); }
             
            }
           
        }
  return //setisOpenLogin(false)
}.bind(this)
  //Test One drive iframe pas possible car document s'ouvre dans une autre fenêtre
 // {id_documents == 5 ?<CardDocument {...this.props} url_video="https://onedrive.live.com/embed?cid=CCE819EC89F4DDE9&resid=CCE819EC89F4DDE9%21332163&authkey=AC59_u58GzB75Yg" objectif="Document sur One Drive" title_document="Test" description="Test"/>:<div></div>}
 //<iframe src="https://onedrive.live.com/embed?cid=CCE819EC89F4DDE9&resid=CCE819EC89F4DDE9%21332163&authkey=AC59_u58GzB75Yg" width="98" height="120" frameborder="0" scrolling="no"></iframe>
   render() {
    
    
    const {handleCreationCours,config,matiere_id,type_audio,id_documents,youtube_frame,lesson_description,title_lesson,url_video,title_document,description,objectif,isnotdocument,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handlhandleSelectionGetLogineSelectionChangeLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;
  
    return(
      <div style={{display:isnotdocument}}>
      <Card style={{display:'block',width:this.state.force_width,margin:4}}>
        <H4>{title_lesson}</H4><a href="" onClick={(ev)=>{ev.preventDefault();this.setState({isOpen:true})}}>{lesson_description}</a>
        <p>Pour plus d'informations, cliquez <b><a onClick={(ev)=>{ev.preventDefault();this.setState({isOpen:true})}} href="">En savoir plus</a></b>  </p>
        
        <Overlay isOpen={this.state.isOpen} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Création d'un cours</H4>
                        <p>
                           Donnez un titre à votre cours et appuyez sur le bouton "Ajouter un cours"
                        </p>
                        <p>
                            Vous pourrez ensuite ajouter des documents:
                            Vidéo, Audio , texte, images, type Quizz, YouTube, liens Internet ...
                        </p>
                       
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{ev.preventDefault();this.setState({isOpen:false})}} style={{ margin: "" }}>
                                Fermer
                            </Button>
                            
                            
                        </div>
                    </div>
                </Overlay>
        <div></div>
        <input type="text" onChange={(ev)=>this.handleChange(ev)} placeholder="Titre de votre cours"/>
        <Button style={{display: 'block',marginTop:15}} onClick={(ev)=>{ev.preventDefault();this.handleClick()}}>Ajouter un cours</Button>
      </Card>
      <div style={{display:this.state.isDocOpen, flexWrap: 'wrap',width:'100%',backgroundColor:"rgba(245,245,245,0.9"}}>
    
      </div>
      </div>
)
}
}
